import { composeIO } from 'react-compose-io'
import { informacoesModalRegularizacaoErroIO } from './InformacoesModalRegularizacaoErro.IO'
import { InformacoesModalRegularizacaoErroView } from './InformacoesModalRegularizacaoErro.View'

export const InformacoesModalRegularizacaoErro = composeIO(InformacoesModalRegularizacaoErroView, informacoesModalRegularizacaoErroIO)
